import { ContractType } from 'lib/constants';

/**
 * Returns the best eligible fixed-rate contract, or null if none found.
 * Prefers USD contracts over non-USD. If multiple USD contracts exist, picks the highest rate.
 * If no USD contracts exist, picks the highest rate among non-USD contracts.
 * Works with both flat Contract[] (from affiliationsByCompany) and IEmployment[].
 */
export const getEligibleAdvanceContract = (
  contracts: { contractType: string; contractCurrency: string; rate: number; id: string; terminationDetails?: any }[],
) => {
  const eligible = contracts.filter(
    (contract) => contract?.contractType === ContractType.FIXED_RATE && !contract?.terminationDetails,
  );

  if (!eligible.length) return null;

  const usdContracts = eligible.filter((contract) => contract.contractCurrency === 'USD');
  const pool = usdContracts.length ? usdContracts : eligible;

  return pool.sort((a, b) => b.rate - a.rate)[0];
};
